$('.tab:not(.js-tabLink)').on('click', (e) => {
  const current = $(e.currentTarget)
  const siblings = current.parents('.switcher').find('.tab')

  const tabId = current.data('tab-id')

  siblings.removeClass('tab_active')
  current.addClass('tab_active')

  const url = new URL(window.location.href)
  const PROPERTY_PROGRESS_TRACK_TITLE = url.searchParams.get(
    'PROPERTY_PROGRESS_TRACK_TITLE',
  )

  const params = []
  url.searchParams.forEach((_, key) => {
    params.push(key)
  })

  params.forEach((val) => {
    url.searchParams.delete(val)
  })

  url.searchParams.append('tab', tabId)

  if (PROPERTY_PROGRESS_TRACK_TITLE) {
    url.searchParams.append(
      'PROPERTY_PROGRESS_TRACK_TITLE',
      PROPERTY_PROGRESS_TRACK_TITLE,
    )
  }

  window.location.href = url
})
